import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NpcStateTaskStatus } from 'src/app/dto';

@Component({
    selector: 'app-npc-state-task',
    templateUrl: './npc-state-task.component.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NpcStateTaskComponent {
    @Input() task: NpcStateTaskStatus;
}
